import { Menu } from "antd"
import Link from "next/link"
import {
  EyeOutlined,
  InboxOutlined,
  DollarCircleOutlined
} from "@ant-design/icons"
import { ROLE_LABELS } from "../../../helpers/dashboards/roles-labels"
import PropTypes from "prop-types"
import ConfidentialityDisclaimer from "./confidentiality-disclaimer"
import { TrackingService } from "../../../services"
import { MixpanelTracker } from "../../../services/usageTrackingService/mixpanelTracker"

MultiRoleMenu.propTypes = {
  step: PropTypes.string,
  roles: PropTypes.array,
  submenu: PropTypes.string
}

export default function MultiRoleMenu ({ step, submenu, roles }) {

  const onClickTabs = {
    submissions: {
      LOCAL_COUNCIL: () => {
        TrackingService(MixpanelTracker).trackLocalCouncilTab({})
      },
      DIRECTIVE_COUNCIL: () => {
        TrackingService(MixpanelTracker).trackDirectiveCouncilTab({})
      },
      TECHNICAL_COMMITTEE: () => {
        TrackingService(MixpanelTracker).trackTechnicalComitteeTab({})
      }
    },
    projects: {
      actives: () => {
        TrackingService(MixpanelTracker).trackActiveProjectsTab({})
      },
      closed: () => {
        TrackingService(MixpanelTracker).trackClosedProjectsTab({})
      }
    },
    BUDGET_AVAILABILITY: () => {
      TrackingService(MixpanelTracker).trackBudgetAvailability({})
    }
  }

  return (
    <>
      <Menu
        defaultSelectedKeys={[step]}
        defaultOpenKeys={[submenu]}
        theme="dark"
        className="fico main-menu"
        mode="inline"
        onClick={({ keyPath }) =>
          keyPath.length > 1 ?
            onClickTabs?.[keyPath[1]]?.[keyPath[0]]?.(keyPath) :
            onClickTabs?.[keyPath[0]]?.()
        }>
        <Menu.SubMenu
          key="submissions"
          icon={<InboxOutlined />}
          title="Solicitudes">
          <Menu.Item key="SUBMISSIONS_RESUME">
            <Link href={"/dashboards/submissions"}>
              Resumen de solicitudes por aprobar
            </Link>
          </Menu.Item>
          {roles?.split(" | ").map(role => (
            <Menu.Item key={role}>
              <Link href={`/dashboards/submissions/${role.toLowerCase()}`}>
                {ROLE_LABELS[role]}
              </Link>
            </Menu.Item>
          ))}
          <Menu.Item key="ON_AGREEMENT">
            <Link href="/dashboards/submissions/on_agreement">
              Convenio
            </Link>
          </Menu.Item>
          <Menu.Item key="REJECTED">
            <Link href="/dashboards/submissions/rejected">
              Rechazadas
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
        <Menu.SubMenu
          key="projects"
          icon={<EyeOutlined />}
          title="Proyectos">
          <Menu.Item key="PROJECTS_RESUME">
            <Link href={"/dashboards/projects"}>
              Resumen de proyectos aprobados
            </Link>
          </Menu.Item>
          <Menu.Item key="actives">
            <Link href={"/dashboards/projects/actives"}>
              Activos
            </Link>
          </Menu.Item>
          <Menu.Item key="closed">
            <Link href={"/dashboards/projects/closed"}>
              Concluidos
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
        <Menu.Item icon={<DollarCircleOutlined />} key="BUDGET_AVAILABILITY">
          <Link href={"/admin/budget-availability"}>
            Disponibilidad presupuestal
          </Link>
        </Menu.Item>
      </Menu>
      <ConfidentialityDisclaimer />
    </>
  )
}
